




















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { AspectSelectInfo } from '@/app/shared/models';
import { SerializedAspectValueDescriptor } from '@xlearn/common';
import AspectDropdownComponent from '@/app/aspect/components/aspect-dropdown-component.vue';

@Component({
  components: {
    AspectDropdownComponent
  }
})
export default class AspectComponent extends Vue {
  @Prop()
  public aspects: AspectSelectInfo[];

  private currentLevel: number = 0;
  private aspectIdsByLevel: { [level: number]: string } = {};

  private aspectValues(level: number): SerializedAspectValueDescriptor[]|null {
    const aspect = this.aspects.find((a) => a.level === level);
    if (!aspect) {
      return null;
    }

    return aspect.values;
  }

  private instanceNames(level:number): string | null {
    const aspect = this.aspects.find((a) => a.level === level);
    if (!aspect) {
      return null;
    }

    return aspect.name;
  }

  private onAspectClicked(level: number, id: string): void {
    this.aspectIdsByLevel[level] = id;
    this.currentLevel = level + 1;
    const newValues = this.aspectValues(this.currentLevel);
    const noMoreLevels: boolean = newValues === null;
    if (noMoreLevels) {
      this.emitSelected();
    }
  }

  @Emit('selected')
  private emitSelected(): string {
    return this.createAspectInstanceId();
  }

  private createAspectInstanceId(): string {
    let items: string[] = [];
    for (let i = 0; i < this.currentLevel; i++) {
      items = [...items, this.aspectIdsByLevel[i]];
    }

    return items.join('-');
  }
}
